module.exports = __webpack_public_path__ + "img/avatar-placeholder.5c415dbc.png";